import React, { useState, useEffect, useRef } from 'react';
import Image from '../assets/NewHome/image1.jpg';
import { ArrowLeft, ArrowRight } from 'react-bootstrap-icons';
import { FiTrendingUp, FiArrowUp } from 'react-icons/fi';
import BackgroundImage from '../assets/NewHome/background2.svg'
const CaseStudyCarouselContent = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const containerRef = useRef(null);

  const carouselData = [
    {
      clientName: 'Samsung Galaxy',
      clientDescription: 'Automation of routine tasks with AI to focus on higher-value tasks.',
      testimonial: "Automate your consulting sales process and increase winnability. Get actionable lead signals tailored to your offerings and past work, while intelligently tracking your focus accounts and key people. Make your business development efforts timely and consistent by proactively building a pipeline.",
      image: '/api/placeholder/600/800',
      stats: [
        {
          value: '3X',
          description: 'More proposals sent to clients by reducing a lot of manual work',
          icon: FiTrendingUp
        },
        {
          value: '60%',
          description: 'time saved on research, spend more time on billable work',
          icon: FiArrowUp
        },
        {
          value: '45%',
          description: 'automation of routine tasks with AI to focus on higher-value tasks',
          icon: FiArrowUp
        }
      ]
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselData.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselData.length) % carouselData.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselData.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [carouselData.length]);

  const currentData = carouselData[currentSlide];

  return (
    <div 
      ref={containerRef}
      className="rounded-[35px] flex bg-[#4F54FF] flex-col relative overflow-hidden"
    >
      <img src={BackgroundImage} alt="Background" className="absolute top-0 left-0 w-full h-full object-cover opacity-30" />
      
      <div className="relative h-full transition-all duration-700 ease-in-out">
        <div className="flex flex-col lg:flex-row h-full gap-8">
          
          {/* Left Section - Content */}
          <div className="w-full lg:w-[70%] p-20 lg:p-12 xl:p-20 pr-0 flex flex-col justify-center z-10">
            <h1 
              className="text-4xl md:text-5xl font-extralight text-white mb-6 transition-all duration-500"
              style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}
            >
              Key Benefits
            </h1>

            <p 
              className="text-base font-extralight text-white leading-relaxed mb-6 max-w-xl transition-all duration-500"
              style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}
            >
              {currentData.testimonial}
            </p>

            <div className="flex gap-4 lg:gap-4 mt-12">
              {currentData.stats.map((stat, index) => (
                <div 
                  key={index} 
                  className="flex relative flex-col transition-all duration-500"
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <div 
                    className="text-4xl md:text-5xl font-extralight text-white mb-2" 
                    style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}
                  >
                    {stat.value}
                  </div>
                  <p 
                    className="text-xs text-white/90 leading-relaxed max-w-[200px]" 
                    style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}
                  >
                    {stat.description}
                  </p>
                </div>
              ))}
            </div>

            {/* <button 
              className="bg-white text-gray-900 px-8 py-3 w-fit rounded-full font-medium hover:bg-gray-100 transition-all duration-300 shadow-lg text-sm"
              style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}
            >
              Read Case Study
            </button> */}
          </div>

          {/* Right Section - Image & Client Card */}
          <div className="w-full lg:w-[30%] relative flex items-center justify-end">
            <div className="relative w-full h-full flex items-center justify-end">
              <div 
                className="relative w-auto max-w-sm h-[500px] p-4 overflow-hidden"
              >
                <img 
                  src={Image}
                  alt={currentData.clientName}
                  className="w-full h-full object-cover rounded-[25px]"
                />
                
                {/* <div 
                  className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"
                /> */}
              </div>

              {/* <div className="absolute bottom-8 left-4 w-56 right-4 z-30">
                <div 
                  className="bg-white rounded-2xl p-6 shadow-2xl transform transition-all duration-700"
                >
                  <h3 
                    className="text-xl font-semibold text-gray-900 mb-2" 
                    style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}
                  >
                    {currentData.clientName}
                  </h3>
                  <p 
                    className="text-sm text-gray-700 leading-relaxed" 
                    style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}
                  >
                    {currentData.clientDescription}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Carousel Navigation */}
      {/* <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-40">
        <div className="flex items-center gap-3 px-5 py-3">
          <button
            onClick={prevSlide}
            className="text-[#BBD0FF] hover:text-white transition-colors duration-300 cursor-pointer"
            aria-label="Previous slide"
          >
            <ArrowLeft size={20} />
          </button>

          <div className="flex items-center gap-2">
            {carouselData.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
                className={`transition-all duration-300 ${
                  currentSlide === index
                    ? 'w-12 h-2 bg-white rounded-full shadow-inner'
                    : 'w-2 h-2 bg-white/60 rounded-full hover:bg-white/90'
                }`}
              />
            ))}
          </div>

          <button
            onClick={nextSlide}
            className="text-[#BBD0FF] hover:text-white transition-colors duration-300"
            aria-label="Next slide"
          >
            <ArrowRight size={20} />
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default CaseStudyCarouselContent;

